import Header from "../../header/Header";
import ExperienceInfo from "../experience_info/ExperienceInfo";
import Footer from "../../footer/Footer";

function ExperienceLanding(){
    return(
        <div className="experience_landing">
            <Header />
            <ExperienceInfo />
            <Footer />
        </div>
    )
}

export default ExperienceLanding